export class AskBrainSourceData {
    constructor() {
        this.index = 0;
        this.source = "";
        this.domain_name = "";
        this.favicon = "";
        this.excerpt = "";
    }
}
export class AskBrainData {
    constructor() {
        this.query = "";
        this.answer = "";
    }
}
